import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { ModalPainel } from "@/components/ModalPainel";
import { useSave } from "../service";
import { FormValues } from "../model";
import { Form } from "../children/Form";
import { useState } from "react";
import ModalRetorno from "@/components/components/ModalRetorno";

export function UsuarioCreate() {
  const { mutateAsync } = useSave();
  const navigate = useNavigate();

  const [isRetornoOpen, setIsRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  async function handleSave(values: FormValues) {
    try {
      await mutateAsync(values);
      setMensagemRetorno('Usuário criado com sucesso!');
      setTipoRetorno('sucesso');
      setIsRetornoOpen(true);
    } catch (e: any) {
      setMensagemRetorno(
        e?.response?.data?.mensagem ||
        JSON.stringify(e?.response?.data || e)
      );
      setTipoRetorno('erro');
      setIsRetornoOpen(true);
    }
  }

  return (
    <>
      <ModalPainel>
        <Box p={5}>
          <Form title="Criar Usuário" handleSave={handleSave} />
        </Box>
      </ModalPainel>

      <ModalRetorno
        isOpen={isRetornoOpen}
        onClose={() => {
          setIsRetornoOpen(false);
          if (tipoRetorno === 'sucesso') {
            navigate("/painel/cadastro-de-usuarios");
          }
        }}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
